export const HTTP_METHODS = Object.freeze({
	GET: "GET",
	POST: "POST",
	PUT: "PUT",
	PATCH: "PATCH",
	DELETE: "DELETE"
});

export type HttpMethod = (typeof HTTP_METHODS)[keyof typeof HTTP_METHODS];
